import { remToPx } from './remToPx';
const tokenCache = new WeakMap();
export function getTokenPxValue(token, element = document.documentElement, defaultValue) {
    var _a;
    const cachedTokens = tokenCache.get(element);
    if (cachedTokens === null || cachedTokens === void 0 ? void 0 : cachedTokens[token]) {
        return cachedTokens[token];
    }
    const tokenValue = getComputedStyle(element).getPropertyValue(token);
    const numberValue = Number((_a = tokenValue.match(/-?[\d.]+/)) === null || _a === void 0 ? void 0 : _a[0]);
    let returnValue = numberValue || defaultValue;
    if (/rem/.test(tokenValue)) {
        returnValue = remToPx(numberValue);
    }
    tokenCache.set(element, {
        ...cachedTokens,
        [token]: returnValue,
    });
    return returnValue;
}
//# sourceMappingURL=getTokenPxValue.js.map